import Vue from "vue";
import Vuex from 'vuex'
import Router from 'vue-router'

Vue.use(Router);
Vue.use(Vuex);